export const SIGN_UP_URL = '/identity/api/v1/sign-up';
export const SIGN_UP_CONFIRM_URL = '/identity/api/v1/sign-up/confirm';
export const SIGN_UP_CONFIRM_RESEND_URL = '/identity/api/v1/sign-up/confirm/resend';
